import styled from 'styled-components';

export const Main = styled.div`
   width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   .select {
      margin-bottom: 10px;
      h4 { width: 65px; }
   }
   .textInput {
      margin-bottom: 10px;
      h4 { width: 85px; }

      &:last-of-type {
         margin-bottom: 0;
      }
   }
   .textarea {
      margin-top: 30px;

      &:last-of-type {
         margin-top: 25px;
      }
      > div {
         height: 100px;
         min-height: 100px;
      }
   }
   .retrySettings {
      margin-top: 18px;
      padding-top: 14px;
      border-top: 1px solid rgba(148, 163, 184, 0.28);

      .switch {
         justify-content: flex-start;
      }
   }
   .retryFields {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;
      margin-top: 12px;

      .textInput {
         margin-bottom: 0;

         h4 {
            width: 74px;
         }
      }
   }
`;
